/** @typedef {{ width: number, height: number }} ScreenResolution */
/** @typedef {{ orientation?: string, screenResolution?: ScreenResolution }} DisplayProfile */

const DEFAULT_PROFILE = {
  orientation: 'landscape',
  screenResolution: { width: 1920, height: 1080 },
};

let resizeListener = null;

/**
 * Scale factor: fit logical stage in window, never upscale past 1:1 (letterbox on larger screens).
 * @param {number} stageW
 * @param {number} stageH
 */
export function computeStageScale(stageW, stageH) {
  const w = Math.max(1, stageW);
  const h = Math.max(1, stageH);
  return Math.min(window.innerWidth / w, window.innerHeight / h, 1);
}

/**
 * @param {DisplayProfile | null | undefined} profile
 */
export function applyDisplayProfile(profile) {
  const stage = document.getElementById('player-stage');
  if (!stage) return;

  const resolved = {
    orientation: profile?.orientation ?? DEFAULT_PROFILE.orientation,
    screenResolution: {
      width: profile?.screenResolution?.width ?? DEFAULT_PROFILE.screenResolution.width,
      height: profile?.screenResolution?.height ?? DEFAULT_PROFILE.screenResolution.height,
    },
  };

  const { width, height } = resolved.screenResolution;
  stage.dataset.orientation = resolved.orientation;
  stage.style.width = `${width}px`;
  stage.style.height = `${height}px`;

  const fit = () => {
    const scale = computeStageScale(width, height);
    stage.style.transformOrigin = 'top left';
    stage.style.transform = `scale(${scale})`;
  };

  if (!resizeListener) {
    resizeListener = fit;
    window.addEventListener('resize', resizeListener);
  }
  fit();
}
